import AccordianCategoriesPanel from '@/components/templates/ProductCategoriesPanel';
import ModuleProducts from '@/utils/functions/Modules/products';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import { useEffect, useState } from 'react';

interface CustomTabPanelProps {
    children?: React.ReactNode;
    value: number;
    index: number;
    [key: string]: any;
}

function CustomTabPanel(props: CustomTabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography component={'div'}>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

export default function AccordianCategories({ categories }: any) {
    
    const [tabs, setTabs] = useState([]);

    useEffect(() => {
        if (categories) {
            setTabs(categories);
        }
    }, []);

    return (
        <Box sx={{ width: '100%' }}>
            {tabs && <AccordianCategoriesPanel tabs={tabs} />}
        </Box>
    );
}
